/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "parts/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/6.jpg";
import team2 from "assets/images/22.jpg";
import team3 from "assets/images/16.jpg";
import team4 from "assets/images/35.jpg";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="info"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
            Why Choose Our Cyber Security Services?
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
              At HP Tech Solutions, we are more than just a service provider—we are your trusted partner in cybersecurity. Our mission is to deliver innovative, secure, and scalable solutions that protect businesses from evolving threats and ensure their operations remain resilient in a rapidly changing digital world.

              Founded by a team of experienced professionals, we specialize in implementing advanced security strategies, from robust threat detection and prevention to comprehensive risk management frameworks. Whether you need to safeguard sensitive data, fortify your infrastructure, or meet compliance requirements, we offer tailored cybersecurity solutions to meet your unique needs.
            </MKTypography>

          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="Comprehensive Threat Detection"
                position={{ color: "info", label: "user-friendly" }}
                description="We provide end-to-end protection, detecting a wide range of attack types and security vulnerabilities."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="Real-Time Monitoring & Alerts"
                position={{ color: "info", label: "threat detection" }}
                description="Continuous surveillance ensures that threats are identified and mitigated quickly."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="Proactive Prevention"
                position={{ color: "info", label: "specific business goals" }}
                description="Our solutions focus on preventing attacks before they can cause damage, reducing risk and exposure."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Expert Team"
                position={{ color: "info", label: "maximize ROI" }}
                description="Our cybersecurity experts are highly skilled at defending against the latest threats and vulnerabilities."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
